import axios from 'axios';
import { API_URL } from '../config';

import initialState from './initialState';

export const getSpecifications = ({ specifications }) => specifications;

const reducerName = 'specifications';
const createActionName = (name) => `app/${reducerName}/${name}`;
const LOAD_SPECIFICATIONS = createActionName('LOAD_SPECIFICATIONS');
const ADD_SPECIFICATION = createActionName('ADD_SPECIFICATION');
const EDIT_SPECIFICATION = createActionName('EDIT_SPECIFICATION');
const DELETE_SPECIFICATION = createActionName('DELETE_SPECIFICATION');

export const loadSpecifications = (payload) => ({
  payload,
  type: LOAD_SPECIFICATIONS,
});
export const addSpecification = (payload) => ({
  payload,
  type: ADD_SPECIFICATION,
});
export const editSpecification = (payload) => ({
  payload,
  type: EDIT_SPECIFICATION,
});
export const deleteSpecification = (payload) => ({
  payload,
  type: DELETE_SPECIFICATION,
});

export const loadSpecificationsRequest = () => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/lab-parameters`, {
        withCredentials: true,
      });

      dispatch(loadSpecifications(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const loadSpecificationByIdRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/lab-parameters/${id}`, {
        withCredentials: true,
      });

      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const addSpecificationRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/lab-parameters`, data, {
        withCredentials: true,
      });
      dispatch(addSpecification(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const editSpecificationRequest = (data, id) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/lab-parameters/${id}`, data, {
        withCredentials: true,
      });
      dispatch(editSpecification(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const deleteSpecificationRequest = (id) => {
  return async (dispatch) => {
    try {
      await axios.delete(`${API_URL}/lab-parameters/${id}`, {
        withCredentials: true,
      });
      dispatch(deleteSpecification(id));
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const updateBasicDataSpecificationRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/lab-parameters/${data.id}`, data, {
        withCredentials: true,
      });
      dispatch(editSpecification(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const updateLabSpecificationRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(
        `${API_URL}/lab-parameters/specification/${data.id}`,
        data,
        {
          withCredentials: true,
        },
      );
      dispatch(editSpecification(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const createBrandSpecificationRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(
        `${API_URL}/lab-parameters/brand-specification`,
        data,
        {
          withCredentials: true,
        },
      );
      dispatch(editSpecification(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const deleteBrandSpecificationRequest = (id) => {
  return async (dispatch) => {
    try {
      await axios.delete(`${API_URL}/lab-parameters/specification/${id}`, {
        withCredentials: true,
      });
      dispatch(deleteSpecification(id));
    } catch (e) {
      console.log(e.message);
    }
  };
};
const specificationsReducer = (statePart = initialState, action) => {
  switch (action.type) {
    case LOAD_SPECIFICATIONS:
      return [...action.payload];
    case ADD_SPECIFICATION:
      return [...statePart, action.payload];
    case EDIT_SPECIFICATION:
      return statePart.map((el) =>
        el.id === action.payload.id ? action.payload : el,
      );
    case DELETE_SPECIFICATION:
      return statePart.filter((el) => el.id !== action.payload);
    default:
      return statePart;
  }
};
export default specificationsReducer;
